import { LEGAL_REVIEW_NOTICE, PLATFORM_LEGAL_DISPLAY_NAME } from "@bw/shared";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Alert from "@mui/material/Alert";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

const PUBLIC_PRIVACY_POLICY_URL = "https://badmintonwarriors.com/privacy";

export function DoNotSellPage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: "100dvh", bgcolor: "background.default" }}>
      <AppBar
        component="header"
        position="sticky"
        color="inherit"
        elevation={0}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Toolbar sx={{ maxWidth: 960, width: "100%", mx: "auto", gap: 1 }}>
          <IconButton aria-label="Go back" edge="start" onClick={() => navigate(-1)}>
            <ArrowBack />
          </IconButton>
          <Typography component="h1" variant="h6" sx={{ fontWeight: 700 }}>
            Do Not Sell or Share My Personal Information
          </Typography>
        </Toolbar>
      </AppBar>

      <Container component="main" maxWidth="md" sx={{ py: { xs: 4, sm: 6 } }}>
        <Stack spacing={4}>
          <Typography color="text.secondary" variant="body2">
            California Privacy Rights Act (CPRA)
          </Typography>
          <Alert severity="warning">{LEGAL_REVIEW_NOTICE}</Alert>

          <Box component="section">
            <Typography component="h2" variant="h5" sx={{ fontWeight: 700 }}>
              Your Right to Opt Out
            </Typography>
            <Typography sx={{ mt: 1.5 }}>
              Under the California Privacy Rights Act (CPRA) and the California
              Consumer Privacy Act (CCPA), California residents have the right to
              opt out of the sale or sharing of their personal information.
            </Typography>
          </Box>

          <Box component="section">
            <Typography component="h2" variant="h5" sx={{ fontWeight: 700 }}>
              Our Practices
            </Typography>
            <Typography sx={{ mt: 1.5, fontWeight: 700 }}>
              We do not sell or share your personal information
              with third parties for monetary or other valuable consideration.
            </Typography>
            <Typography sx={{ mt: 1.5 }}>
              We do not engage in the sale of personal information as defined by
              CCPA/CPRA. We do not share your personal information with third
              parties for cross-context behavioral advertising purposes.
            </Typography>
            <Typography sx={{ mt: 1.5 }}>
              The limited sharing we do is strictly for providing our services to
              you (for example, sharing your booking details with the facility you
              booked, or processing payments through Stripe). These are considered
              service provider relationships, not “sales” or “sharing” under
              California law.
            </Typography>
          </Box>

          <Box component="section">
            <Typography component="h2" variant="h5" sx={{ fontWeight: 700 }}>
              Your Additional Rights
            </Typography>
            <Typography sx={{ mt: 1.5 }}>
              As a California resident, you also have the right to:
            </Typography>
            <Box component="ul" sx={{ my: 1.5, pl: 3 }}>
              <li>
                <Typography component="span">
                  <strong>Know</strong> what personal information we collect and
                  how we use it
                </Typography>
              </li>
              <li>
                <Typography component="span">
                  <strong>Delete</strong> your personal information
                </Typography>
              </li>
              <li>
                <Typography component="span">
                  <strong>Correct</strong> inaccurate personal information
                </Typography>
              </li>
              <li>
                <Typography component="span">
                  <strong>Non-discrimination</strong> for exercising your privacy
                  rights
                </Typography>
              </li>
            </Box>
            <Typography>
              For more details, please review our full{" "}
              <Link href={PUBLIC_PRIVACY_POLICY_URL}>Privacy Policy</Link>.
            </Typography>
          </Box>

          <Box component="section">
            <Typography component="h2" variant="h5" sx={{ fontWeight: 700 }}>
              Contact Us
            </Typography>
            <Typography sx={{ mt: 1.5 }}>
              If you have questions about our data practices or wish to exercise
              any of your California privacy rights, please contact us at:
            </Typography>
            <Typography sx={{ mt: 1.5 }}>
              {PLATFORM_LEGAL_DISPLAY_NAME}
              <br />
              Privacy Team
              <br />
              Email:{" "}
              <Link href="mailto:privacy@badmintonwarriors.com">
                privacy@badmintonwarriors.com
              </Link>
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
